export default {
  label: {
    replierName: 'Atendente',
    rating: 'Avaliação',
    viewRating: 'Abrir avaliação',
    button: {
      view: 'Abrir publicação',
      apply: 'Aplicar filtros',
      clear: 'Limpar filtros',
    },
    table: {
      header: {
        userName: 'Usuário',
        surveyScore: 'Avaliação',
        surveyComment: 'Comentário',
        replierName: 'Atendente',
        responseAt: 'Data da avaliação',
        seeRating: 'Ver avaliação',
      },
    },
  },
  faq: {
    title: 'O que é?',
    description: 'Lista de notas e comentários que cada usuário realizou dentro da Pesquisa de Satisfação.',

    faq01: {
      title: 'Como realizo o filtro de avaliações?',
      description: 'A posição da estrela que será preenchida ao clicar será filtrada, exemplo, primeira e terceira posição preenchida: aparecerá apenas avaliações de 1 e 3 estrelas.',
    },
    faq02: {
      title: 'É possível obter a lista de avaliação operadores específicos?',
      description: 'Sim, é possível realizar o filtro por usuário que irá listar todas avaliações do respondente específico.',
    },
  },
};
